var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PaginatedRecipeSearchType, } from '../../../models';
import { useRepositories } from '../../../contexts';
import { InvalidationTag, LoaderType, useAppInfiniteQuery } from '../utils';
export var useGetRecipes = function (_a) {
    var _b = _a.searchType, searchType = _b === void 0 ? PaginatedRecipeSearchType.SEARCH_PAGE : _b, enabled = _a.enabled, _c = _a.loader, loader = _c === void 0 ? LoaderType.None : _c, params = __rest(_a, ["searchType", "enabled", "loader"]);
    var _d = useRepositories(), planRepo = _d.planRepo, recipeRepo = _d.recipeRepo;
    var invalidationType = searchType === PaginatedRecipeSearchType.SEARCH_PAGE
        ? InvalidationTag.Recipes
        : InvalidationTag.Plan;
    var _e = useAppInfiniteQuery({
        key: [invalidationType, params !== null && params !== void 0 ? params : {}],
        fetch: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var _c, reqBodyPlanMeal, reqBodyPlanRecipe, reqBodyRecipeSearch;
            var pageParam = _b.pageParam, queryKey = _b.queryKey;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _c = searchType;
                        switch (_c) {
                            case PaginatedRecipeSearchType.PLAN_MEAL: return [3 /*break*/, 1];
                            case PaginatedRecipeSearchType.PLAN_RECIPE: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1:
                        reqBodyPlanMeal = queryKey[1];
                        return [4 /*yield*/, planRepo.getCustomMealRecipe(__assign(__assign({}, reqBodyPlanMeal), { filters: __assign(__assign({}, reqBodyPlanMeal.filters), pageParam) }))];
                    case 2: return [2 /*return*/, (_d.sent()).recipes];
                    case 3:
                        reqBodyPlanRecipe = queryKey[1];
                        return [4 /*yield*/, planRepo.findPlanRecipeAlternative(__assign(__assign({}, reqBodyPlanRecipe), { filters: __assign(__assign({}, reqBodyPlanRecipe.filters), pageParam) }))];
                    case 4: return [2 /*return*/, _d.sent()];
                    case 5:
                        reqBodyRecipeSearch = queryKey[1];
                        return [4 /*yield*/, recipeRepo.getRecipes(__assign(__assign({}, reqBodyRecipeSearch), pageParam))];
                    case 6: return [2 /*return*/, _d.sent()];
                }
            });
        }); },
        configs: {
            getNextPageParam: function (paginatedItems) {
                var _a;
                if (!((_a = paginatedItems.pagination) === null || _a === void 0 ? void 0 : _a.hasMore)) {
                    return;
                }
                return paginatedItems.pagination.nextPage;
            },
            enabled: enabled,
            retry: false,
        },
        loader: loader,
    }), data = _e.data, isFetching = _e.isFetching, fetchNextPage = _e.fetchNextPage, refetch = _e.refetch;
    return {
        dataItems: data === null || data === void 0 ? void 0 : data.pages,
        dataPagination: data === null || data === void 0 ? void 0 : data.pageParams,
        isFetching: isFetching,
        fetchNextPage: fetchNextPage,
        refetch: refetch,
    };
};
